import { render, staticRenderFns } from "./AffiliateCompanies.vue?vue&type=template&id=63fc0fb0&"
import script from "./AffiliateCompanies.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports